import { Button, TextField, Checkbox, Autocomplete, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CloseIcon from "@mui/icons-material/Close";
import {
  AdminItemsRow,
  AdminItemsContainer,
  AdminItemContainer,
  AdminInviteDetailsContainer,
  AdminInviteDetails,
  AdminItemContainerForm,
  AdminItemContainerChip,
} from "../../admin.styled";
import { Invite } from "../../admin.type";
import { useState } from "react";
import { Toast } from "core/components/global/toast/toast";
import { ConfirmationDialog } from "core/components/global/confirmationDialogBox/confirmationDialog";
import { deleteInvite } from "modules/agentMySecurity/services/embeddingsService";
import { CustomConfirmationDialog } from "./invite.styled";


export default function AdminInvite({
  invite,
  amsUser,
  handleUpdateInvite,
  availableGroups,
  onDelete
}) {
    const [openRow, setRowOpen] = useState({});
    const [description, setDescription] = useState<string>(invite.description);
    const [email, setEmail] = useState<string>(invite.email);
    const [isActive, setIsActive] = useState<boolean>(invite.active);
    const [isUsed, setIsUsed] = useState<boolean>(invite.used);
    const [groups, setGroups] = useState<string[]>(invite.groupAssignments);
    const [openDialog, setOpenDialog] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const handleSetRowOpen = (id) => {
        if (openRow.hasOwnProperty(id)) {
            setRowOpen((prevState) => ({
                ...prevState,
                [id]: !prevState[id],
            }));
        } else {
            setRowOpen((prevState) => ({
                ...prevState,
                [id]: true,
            }));
        }
    };

    const preHandleUpdateInvite = () => {
        handleUpdateInvite({
            _id: invite._id,
            description: description,
            email: email,
            isActive: isActive,
            isUsed: isUsed,
            groups: groups
        })
    }

    // Locally update the list of invites
    const handleInviteChange = (currentInvite: Invite, field: string, value: any) => {
        if (field === "description") {
            setDescription(value);
        } else if (field === "email") {
            setEmail(value);
        } else if (field === "active") {
            setIsActive(!isActive);
        } else if (field === "used") {
            setIsUsed(value);
        } else if (field === "groupAssignments") {
            setGroups(value)
        }
    };

    const handleRemoveGroup = (groupName: string) => {
        setGroups(groups.filter((group) => group !== groupName))
    }

    const handleDeleteClick = () => {
        setOpenDialog(true);
    };
    
    const handleDelete = async () => {
    try {
        setIsDeleting(true);
        const response = await deleteInvite(invite._id);
        if (response !== null) {
        onDelete(invite._id);
        Toast("Invite deleted successfully", "success");
        } else {
        Toast("Failed to delete invite", "error");
        }
    } catch (error) {
        console.error("Delete error:", error);
        Toast("Error deleting invite", "error");
    } finally {
        setIsDeleting(false);
        setOpenDialog(false);
    }
    };

    return (
        <AdminItemsRow>
            <div className="unexpanded-row-container">
                <div className="row-items" onClick={() => handleSetRowOpen(invite._id)}>
                    <p className="row-item">{invite.email}</p>
                    <p className="row-item">{invite.description}</p>
                </div>
                <div className="row-buttons">
                    <IconButton onClick={handleDeleteClick} disabled={isDeleting}>
                        <DeleteOutlineOutlinedIcon fontSize="small" color="error" />
                    </IconButton>
                </div>
            </div>

            {openRow[invite._id] && (
                <AdminItemsContainer>
                    <AdminInviteDetailsContainer>
                    <AdminItemContainer>
                        <strong>Description:</strong>
                        <TextField
                            value={description}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (value.length <= 2000) {
                                handleInviteChange(invite, "description", value);
                                }
                            }}
                            disabled={amsUser?.email === invite.email}
                            variant="outlined"
                            fullWidth
                            />

                    </AdminItemContainer>
                    <AdminItemContainer>
                        <strong>Email:</strong>
                        <TextField
                            value={email}
                            onChange={(e) =>
                                handleInviteChange(invite, "email", e.target.value)
                            }
                            disabled={amsUser?.email === invite.email ? true : false}
                            variant="outlined"
                            fullWidth
                        />
                    </AdminItemContainer>
                    <AdminItemContainer>
                        <strong>Groups:</strong>
                        <AdminItemContainerForm fullWidth>
                            <Autocomplete
                                multiple
                                value={groups}
                                onChange={(event, newGroups) => handleInviteChange(invite, "groupAssignments", newGroups)}
                                options={availableGroups}
                                getOptionLabel={(option) => option}
                                isOptionEqualToValue={(option, value) => option === value}
                                renderTags={(inputed) =>
                                    inputed.map((option, index) => (
                                    <AdminItemContainerChip
                                        className="m-1"
                                        label={option}
                                        key={`invite-group-list-index-${option}`}
                                        onDelete={() => handleRemoveGroup(option)}
                                        deleteIcon={<CloseIcon />}
                                        variant="outlined"
                                        disabled={amsUser?.email === invite.email ? true : false}
                                    />
                                    ))
                                }
                                renderInput={(params) => (
                                    <TextField
                                    {...params}
                                    label=""
                                    className="custom-input"
                                    variant="outlined"
                                    disabled={amsUser?.email === invite.email ? true : false}
                                    />
                                )}
                            />
                        </AdminItemContainerForm>
                    </AdminItemContainer>
                    <AdminInviteDetails>
                        <Checkbox
                            checked={isActive}
                            onChange={(e) =>
                                handleInviteChange(invite, "active", e.target.value)
                            }
                            disabled={amsUser?.email === invite.email ? true : false}
                        />
                        <strong className="ms-2">Active</strong>
                    </AdminInviteDetails>
                    <AdminInviteDetails>
                        <Checkbox
                            checked={isUsed}
                            onChange={(e) =>
                                handleInviteChange(invite, "used", e.target.checked)
                            }
                            disabled={amsUser?.email === invite.email ? true : false}
                        />
                        <strong className="ms-2">Used</strong>
                    </AdminInviteDetails>
                    </AdminInviteDetailsContainer>

                    <Button
                        color="primary"
                        onClick={() => preHandleUpdateInvite()}
                        variant="outlined"
                        disabled={amsUser?.email === invite.email ? true : false}
                    >
                        Update Invite
                    </Button>
                </AdminItemsContainer>
            )}
            <CustomConfirmationDialog
                open={openDialog}
                title="Confirm Delete"
                message={`Are you sure you want to delete the invite for ${invite.email}?`}
                isLoading={isDeleting}
                onClose={() => setOpenDialog(false)}
                onConfirm={handleDelete}
            />
        </AdminItemsRow>
    );
}
